export const MainEvent = {
  MainPageGetStartedClick: 'main_page_get_started_click',
  MainPageAppLinkClick: 'main_page_app_link_click',
  MainPageAllProductsClick: 'main_page_all_products_click',
  MainPageActivityClick: 'main_page_activity_click',
  MainPageFaqClick: 'main_page_faq_click',
  MainPageChatClick: 'main_page_chat_click',
  MainPageScroll: 'main_page_scroll',
  MainPagePromotionCarouselBannerClick: 'promotion_carousel_banner_click',
  CarouselProductClick: 'carousel_product_click', // main page, market page event

  MainPageSignUpEmailClick: 'main_page_sign_up_email_click',
  MainPageDownloadAppClick: 'main_page_download_app_click',
  MainPageTradeNowClick: 'main_page_trade_now_click',
  MarketPageView: 'market_page_view',

  IntroduceCampaignLiveBannerClick: 'introduce_campaign_live_banner_click',
  IntroduceAdvantageLearnMoreClick: 'introduce_advantage_learn_more_click',
  IntroducePartnershipLearnMoreClick: 'introduce_partnership_learn_more_click',
} as const;

export interface MainEventDataType {
  [MainEvent.MainPageAppLinkClick]: {
    app_link?: 'app_store' | 'google_play';
  };
  [MainEvent.CarouselProductClick]: {
    carousel_type: string;
    list_order: number;
    symbol: string;
    current_price: string;
    percentage_diff: string;
  };
  [MainEvent.MainPageActivityClick]: {
    list_order: number;
    activity_name: string;
    activity_start_date: string;
    activity_end_date: string;
  };
  [MainEvent.MainPageFaqClick]: {
    list_order: number;
    question_name: string;
  };
  [MainEvent.MainPageScroll]: {
    section_title: string;
  };
  [MainEvent.MainPagePromotionCarouselBannerClick]: {
    buttun_url: string;
    image_name: string;
  };
  [MainEvent.MainPageSignUpEmailClick]: {};
  [MainEvent.MainPageDownloadAppClick]: {};
  [MainEvent.MainPageTradeNowClick]: {};
  [MainEvent.MarketPageView]: {};
  [MainEvent.IntroduceCampaignLiveBannerClick]: {
    banner_title: string;
    event_location: 'main_page_view';
  };
  [MainEvent.IntroduceAdvantageLearnMoreClick]: {
    section_title: string;
    list_order: number;
    event_location: 'main_page_view';
  };
  [MainEvent.IntroducePartnershipLearnMoreClick]: {
    event_location: 'main_page_view';
  };
}
